/**
 * Defines a map between Merchant and sitemap (allowed components).
 * Keys are Merchant IDs and values are IDs of Sitemaps
 */
export type MerchantAllowedComponents = Record<number, string[]>;
